<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useAuthLogout } from '@/models/auth'

  const route = useRoute()
  const title = computed(() => route.meta.title)
  const logout = useAuthLogout()
</script>

<template>
  <div class="sticky inset-x-0 top-0 z-1 mx-auto max-w-120 rounded-b-xl bg-white/90 p-4 shadow backdrop-blur">
    <div class="flex space-x-4">
      <app-button
        :to="{name: 'home'}"
        class="flex items-center justify-center">
        <fa-icon icon="i-far-house" />
      </app-button>
      <div>|</div>
      <h1 class="flex-1">
        {{ title }}
      </h1>
      <app-button
        class="flex items-center justify-center"
        @click="logout">
        <fa-icon icon="i-far-right-from-bracket" />
      </app-button>
    </div>
  </div>
</template>
